module.exports = __webpack_public_path__ + "img/slide4.0bf05822.png";